export function playNotificationSound(): void {
  const audio = document.getElementById("notificationSound") as HTMLAudioElement;
  const playPromise = audio.play();
  // Check if the promise exists
  if (playPromise !== undefined) {
    playPromise
      .then(() => {
        // Playback started successfully
      })
      .catch((error) => {
        // Autoplay was prevented
        console.log("Audio playback blocked:", error);
        // You could display a "Click to enable sound" message to the user here
      });
  }
}
